// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Procesar {
  background-color: #223263;
  color: #f8f9fa;
  font-size: 1.2rem;
  padding: 2% 15%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box; 
  margin: 0 auto;
}

form {
  justify-content: center;
  width: 100%;
}

.textarea-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;

}

textarea {
  min-width: 100%;
  resize: vertical;
  height: auto;
  margin: 10px 0 0 3px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: "Roboto", sans-serif;
  font-size: 0.6em;
  box-sizing: border-box;
}

textarea::placeholder {
  color: rgba(0, 0, 0, 0.5);
}

.char-counter {
  margin-top: 5px;
  font-size: 0.63em;
  color: #f8f9fa;
}

.botones {
  display: flex;
  gap: 10px;
}

.botones button {
  padding: 5px 10px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.7em;
  cursor: pointer;
  border-radius: 4px;
  width: auto;
  min-width: 120px;

}

.procesar-text {
  background-color: #F8F9FA;
  color: #223263;
  border: 2px solid #F8F9FA;
}

.procesar-file {
  background-color: #223263;
  color: #F8F9FA;
  border: 1px solid #F8F9FA;
  display: none; /* gtsi: 24-04-2025 */
}

.button-with-hint {
  position: relative;
  display: flex;
  flex-direction: row;
  font-size: 1em;
  cursor: pointer;
  background-color: #223263;
  color: #F8F9FA;
  border-radius: 4px;
  padding-top: 2px;
}

.button-with-hint svg:hover{
  transform: scale(1.2); 
  transition: transform 0.3s ease;
}

.file-upload-container {
  display: none; /* gtsi: 24-04-2025 */
  /* display: flex; */ /* gtsi: 24-04-2025 */
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
}

.button-icon {
  margin-right: 8px;
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-icon {
  margin-right: 8px;
  width: 18px;
  height: 18px;
  display: inline-block;
}

@media (max-width: 500px) {
  .Procesar {
    font-size: 1em; 
     
  }

  textarea{
    font-size: 0.4em;
  }
  .char-counter {
    font-size: 0.5em;
  }

  input{
    font-size: 0.6em;
  }

  .botones {
    flex-direction: column;
    margin: 2% 100% 5% 0;
    font-size: 0.7em;
  }
  .botones img{
    width: 14px;
  }
}


.justificado {
  text-align: justify;
  padding-left: 5%;
  padding-right: 5%;
  margin-bottom: 5px;
  font-size: 0.85em;
}

.cursiva {
  font-style: italic;
}

.negrita{
  font-weight: bold;
}

.more-ODS{
  display: flex;
  justify-content: center;
  margin-top: 1%;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Plantilla.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;;AAEb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;AAElB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,aAAa,EAAE,qBAAqB;EACpC,mBAAmB,EAAE,qBAAqB;EAC1C,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,cAAc;;EAEhB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":["\n.Procesar {\n  background-color: #223263;\n  color: #f8f9fa;\n  font-size: 1.2rem;\n  padding: 2% 15%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box; \n  margin: 0 auto;\n}\n\nform {\n  justify-content: center;\n  width: 100%;\n}\n\n.textarea-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  width: 100%;\n\n}\n\ntextarea {\n  min-width: 100%;\n  resize: vertical;\n  height: auto;\n  margin: 10px 0 0 3px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 0.6em;\n  box-sizing: border-box;\n}\n\ntextarea::placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.char-counter {\n  margin-top: 5px;\n  font-size: 0.63em;\n  color: #f8f9fa;\n}\n\n.botones {\n  display: flex;\n  gap: 10px;\n}\n\n.botones button {\n  padding: 5px 10px;\n  font-family: 'Roboto', sans-serif;\n  font-size: 0.7em;\n  cursor: pointer;\n  border-radius: 4px;\n  width: auto;\n  min-width: 120px;\n\n}\n\n.procesar-text {\n  background-color: #F8F9FA;\n  color: #223263;\n  border: 2px solid #F8F9FA;\n}\n\n.procesar-file {\n  background-color: #223263;\n  color: #F8F9FA;\n  border: 1px solid #F8F9FA;\n  display: none; /* gtsi: 24-04-2025 */\n}\n\n.button-with-hint {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  font-size: 1em;\n  cursor: pointer;\n  background-color: #223263;\n  color: #F8F9FA;\n  border-radius: 4px;\n  padding-top: 2px;\n}\n\n.button-with-hint svg:hover{\n  transform: scale(1.2); \n  transition: transform 0.3s ease;\n}\n\n.file-upload-container {\n  display: none; /* gtsi: 24-04-2025 */\n  /* display: flex; */ /* gtsi: 24-04-2025 */\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.button-icon {\n  margin-right: 8px;\n}\n\nbutton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.button-icon {\n  margin-right: 8px;\n  width: 18px;\n  height: 18px;\n  display: inline-block;\n}\n\n@media (max-width: 500px) {\n  .Procesar {\n    font-size: 1em; \n     \n  }\n\n  textarea{\n    font-size: 0.4em;\n  }\n  .char-counter {\n    font-size: 0.5em;\n  }\n\n  input{\n    font-size: 0.6em;\n  }\n\n  .botones {\n    flex-direction: column;\n    margin: 2% 100% 5% 0;\n    font-size: 0.7em;\n  }\n  .botones img{\n    width: 14px;\n  }\n}\n\n\n.justificado {\n  text-align: justify;\n  padding-left: 5%;\n  padding-right: 5%;\n  margin-bottom: 5px;\n  font-size: 0.85em;\n}\n\n.cursiva {\n  font-style: italic;\n}\n\n.negrita{\n  font-weight: bold;\n}\n\n.more-ODS{\n  display: flex;\n  justify-content: center;\n  margin-top: 1%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
